module.exports = __webpack_public_path__ + "static/media/ryan.0f4033e4.jpg";